export function simpleBalance(P: number, r: number, t: number): number {
  return P * (1 + r * t);
}
export function compoundBalance(P: number, r: number, t: number, n: number): number {
  return P * Math.pow(1 + r / n, n * t);
}
export function effectiveAnnualRate(r: number, n: number): number {
  return Math.pow(1 + r / n, n) - 1;
}
export function nominalFromEffective(apy: number, n: number): number {
  return n * (Math.pow(1 + apy, 1 / n) - 1);
}
